import * as React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useField } from 'formik';
import HandleError from '../HandleError';

export default function TextareaComponent({ name, ...props }) {
  const [field] = useField({ name, ...props });
  return (
    <Box
      sx={{
        height: '150px',
      }}
    >
      <TextField
        {...field}
        {...props}
        multiline
        rows={4}
        style={{
          width: '100%',
          height: '126px',
        }}
      />
      <HandleError name={name} />
    </Box>
  );
}
